var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-usable-dropdown',{attrs:{"nameFields":['Name'],"keyField":"Id","items":[_vm.noAnimation ].concat( this.animations)},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }